define('form',['jquery', 'lib/utils', 'form-validation', 'pickerdate', 'select2', 'tooltipster', 'numeral', 'picker', 'wickedpicker'],
    function($, utils, FormValidation, select2, tooltipster, wickedpicker) {

        'use strict';

        var Form = function($form) {

            this.$form = $form;
        };


        Form.prototype.init = function() {

            var _this = this,
                $textareas = this.$form.find('[ data-textarea ]'),
                $datepickersFuture = this.$form.find('[ data-el="datepicker-future" ]'),
                $datepickersPast = this.$form.find('[ data-el="datepicker-past" ]'),
                $datepickersBinded = this.$form.find('.form-field__input--datepicker-binded'),
                $datepickers = this.$form.find('[ data-el="datepicker" ]'),
                $monthpickers = this.$form.find('[ data-el="monthpicker" ]'),
                $months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                $shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                $datepickersWffm = this.$form.find('[data-el="datepicker-wffm" ]'),
                $dp,
                dpOptions,
                dpMax,
                dpLabelId,
                $uploaders = $('[ data-uploader-field ]'),
                $previewRemovers = this.$form.find('[ data-uploader-remove ]'),
                $checkboxToggles = this.$form.find('[ data-checkbox-toggle ]'),
                $selectToggle = this.$form.find('[data-select-toggle]'),
                $legendToggleTarget = this.$form.find('[data-toggle-target]'),
                $termsCheckbox = this.$form.find('[ data-checkbox-terms ]'),
                $formDataTablePost = this.$form.find('[data-table-post]'),
                $formDataTable = this.$form.find('[data-table-form]'),
                $fakecbox2 = $('.form-field--fakecbox2_input'),
                $collapsable = $('.fieldset--collapsable'),
                $checkboxToggle = $('.form-field__input--checkbox--toggle'),
                $select_Toggle = $('.form-field__input--select--toggle'),
                $radioToggle = $('.form-field__radio--toggle'),
                $ratingstar = $('.form-field--ratingstar'),
                $inputBinding = $('.form-field__input--text-binded'),
                $tooltip = $('.form-field__label--tooltip'),
                $tooltip2 = $('.form-dynamic-tooltip'),
                $otp = $('.form-field__input--otp'),
                $hasLimits = $('[data-cbox-max]'),
                $password = $('.form-field__input--password'),
                $passShowHide = $('.form-field__label-password-visibility'),
                defaultOpts = {
                    closeOnSelect: true,
                    format: 'dd mmmm yyyy',
                    formatSubmit: 'dd mmmm yyyy',
                    onStart: function() {
                        // set default date
                        var $dp = this.$node,
                            date;

                        if ($dp.data('initial-date')) {
                            date = new Date($dp.data('initial-date'));
                            this.set('select', [date.getFullYear(), date.getMonth(), date.getDate()]);
                        }
                    },
                    onOpen: function() {
                        _this.scrollIntoView(this.$node);
                    },
                    onClose: function() {
                        this.component.$node.parsley().validate();
                        this.component.$node.trigger('keypress');
                    }
                };

            // arabic translations
            if (utils.isRTL()) {
                defaultOpts.monthsFull = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];
                $shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                defaultOpts.monthsShort = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                defaultOpts.weekdaysShort = ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'];
                defaultOpts.today = 'اليوم';
                defaultOpts.clear = 'مسح';
                defaultOpts.close = 'مغلق';
                defaultOpts.labelMonthNext = 'الشهر القادم';
                defaultOpts.labelMonthPrev = 'الشهر السابق';
                defaultOpts.labelMonthSelect = 'اختر الشهر';
                defaultOpts.labelYearSelect = 'اختر السنة';
                defaultOpts.format = 'dd mmmm yyyy';
                defaultOpts.formatSubmit = 'dd mmm yyyy';
            };

            //for cbox limiting
            $hasLimits.each(function() {
                var $parent = $(this),
                    limit = parseInt($(this).attr('data-cbox-max')),
                    $cboxs = $(this).find('.form-field__input--checkbox');

                $cboxs.each(function () {
                    $(this).off('click.limit').on('click.limit', function (event) {
                         if (!($parent.find('.form-field__input--checkbox:checked').length <= limit) && $(this).prop('checked')) {
                            event.preventDefault();
                         };
                    });
                })
            });

            //for tooltip
            $tooltip.each(function() {
                if (!$(this).hasClass('tooltipstered')) {
                    var text = $(this).attr('tooltip-text');

                    $(this).tooltipster({
                        content: text,
                        maxWidth: 250,
                        arrow: false
                    });
                };
            });

            //for tooltip
            $tooltip2.each(function() {
                if (!$(this).hasClass('tooltipstered')) {
                    var text = $(this).attr('tooltip-text');

                    $(this).tooltipster({
                        content: text,
                        maxWidth: 250,
                        arrow: false
                    });
                };
            });

            //for new fakecbox
            $fakecbox2.each(function() {
                $(this).off('click.fbox').on('click.fbox', function() {
                    var $input = $(this).find('input[type="checkbox"]');

                    $(this).toggleClass('form-field--fakecbox2_input--active');
                    $input.prop("checked", !($input.prop("checked")));
                })
            });

            //for collapsable fields
            setTimeout(function() {
                $collapsable.each(function() {
                    var $field = $(this),
                        $height = 0;

                    $field.children().each(function() {
                        if ($(this).css('display') != 'none') {
                            $height = $height + $(this).outerHeight(true);
                        }
                    });

                    if ($field.hasClass('fieldset--collapsable-closed')) {
                        $field.height($field.find('.legend').outerHeight(true));
                    } else {
                        $field.height($height);
                    };

                    $field.find('.legend').off('click.fcollapse').on('click.fcollapse', function() {
                        $height = 0;
                        $field.children().each(function() {
                            if ($(this).css('display') != 'none') {
                                $height = $height + $(this).outerHeight(true);
                            }
                        });
                        $field.toggleClass('fieldset--collapsable-closed');
                        if ($field.hasClass('fieldset--collapsable-closed')) {
                            $field.height($(this).outerHeight(true));
                        } else {
                            $field.height($height);
                        };
                    });
                });
            }, 500);

            $collapsable.each(function() {
                $(this).off('DOMSubtreeModified').on('DOMSubtreeModified', function() {
                    var $height = 0;
                    $(this).children().each(function() {
                        if ($(this).css('display') != 'none') {
                            $height = $height + $(this).outerHeight(true);
                        }
                    });
                    $(this).height($height);
                });
            });

            //for star rating
            $ratingstar.each(function() {
                var $parent = $(this),
                    $star = $(this).find('.form-field--ratingstar_icon'),
                    $input = $parent.find('.form-field__input--ratingstar');

                if (parseInt($input.val()) != NaN && parseInt($input.val()) != undefined) {
                    for (var i = 0; i < parseInt($input.val()); i++) {
                        if ($($star[i]).hasClass('active')) {
                            $($star[i]).removeClass('active');
                            $star.each(function() {
                                $($star[i]).removeClass('active');
                            });
                        } else {
                            $($star[i]).addClass('active');
                            $($star[i]).prevAll('.form-field--ratingstar_icon').addClass('active');
                        };
                    }
                }

                $star.each(function() {
                    $(this).off('mouseenter.form').on('mouseenter.form', function () {
                        $(this).prevAll('.form-field--ratingstar_icon').addClass('hover');
                    });
                    $(this).off('mouseout.form').on('mouseout.form', function () {
                        $(this).prevAll('.form-field--ratingstar_icon').removeClass('hover');
                    });
                    $(this).off('click.form').on('click.form', function () {
                        if ($(this).hasClass('active')) {
                            $(this).removeClass('active');
                            $star.each(function() {
                                $(this).removeClass('active');
                            });
                        } else {
                            $(this).addClass('active');
                            $(this).prevAll('.form-field--ratingstar_icon').addClass('active');
                        };
                        $parent.find('.form-field__input--ratingstar').val($parent.find('.form-field--ratingstar_icon.active').length);
                        $parent.find('.form-field__input--ratingstar').trigger('focusout');
                        //console.log($parent.find('.form-field__input--ratingstar').val());
                    });
                });
            });

            //for checkbox toggle
            setTimeout(function() {
                $checkboxToggle.each(function() {
                    var target = $(this).attr('toggle-target'),
                        clear = $(this).attr('is-clear');

                    if ($(this).prop('checked')) {
                        $(target).show()
                    } else {
                        $(target).hide()
                    };
                    $(this).closest('.fieldset--collapsable').trigger('DOMSubtreeModified');

                    $(this).off('click.ctoggle').on('click.ctoggle', function() {
                        if ($(this).prop('checked')) {
                            $(target).show()
                        } else {
                            $(target).hide()
                            if (clear == "true") {
                                $(target).find('.form-field__input--radio').prop('checked', false);
                                $(target).find('.form-field__input--checkbox').prop('checked', false);
                                $(target).find('.form-field__input--text').val('');
                            };
                        };
                        $(this).closest('.fieldset--collapsable').trigger('DOMSubtreeModified');
                    });
                });
            }, 250);

            //for radio toggle
            setTimeout(function() {
                $radioToggle.each(function() {
                    $(this).find('.form-field__input--radio').each(function() {
                        var target = $(this).attr('toggle-target'),
                            clear = $(this).attr('is-clear');

                        if ($(this).prop('checked')) {
                            $(target).show()
                        } else {
                            $(target).hide();
                            if (clear == "true") {
                                $(target).find('.form-field__input--radio').prop('checked', false);
                                $(target).find('.form-field__input--checkbox').prop('checked', false);
                                //$(target).find('input').val('');
                            };
                        };

                        $(this).closest('.fieldset--collapsable').trigger('DOMSubtreeModified');

                        $(this).off('click.rtoggle').on('click.rtoggle', function() {
                            $radioToggle.each(function() {
                                $(this).find('.form-field__input--radio').each(function() {
                                    var target = $(this).attr('toggle-target'),
                                        clear2 = $(this).attr('is-clear');

                                    if ($(this).prop('checked')) {
                                        $(target).show()
                                    } else {
                                        $(target).hide()
                                        if (clear2 == "true") {
                                            $(target).find('.form-field__input--radio').prop('checked', false);
                                            $(target).find('.form-field__input--checkbox').prop('checked', false);
                                            $(target).find('.form-field__input--text').val('');
                                        };
                                    };
                                });
                            });
                            $(this).closest('.fieldset--collapsable').trigger('DOMSubtreeModified');
                        });
                    });
                });
            }, 250);

            //for select toggle
            setTimeout(function() {
                $select_Toggle.each(function() {

                    $(this).find('option').each(function() {
                        var target = $(this).attr('toggle-target');

                        if ($(this).prop('selected')) {
                            $(target).show()
                        } else {
                            $(target).hide()
                        };
                    });

                    $(this).closest('.fieldset--collapsable').trigger('DOMSubtreeModified');

                    $(this).off('change.stoggle').on('change.stoggle', function() {
                        $(this).find('option').each(function() {
                            var target = $(this).attr('toggle-target');

                            if ($(this).prop('selected')) {
                                $(target).show()
                            } else {
                                $(target).hide()
                            };
                        });
                        $(this).closest('.fieldset--collapsable').trigger('DOMSubtreeModified');
                    });
                });
            }, 250);

            //for input binding
            $inputBinding.each(function() {
                var $binding_target = $(this).attr('binding-target');

                function binding_activate(elem, isKeyup) {

                    if (!isKeyup) {
                        if ($(elem).hasClass('form-field__input--select')) {
                            $($binding_target).html($(elem).find('option:selected').text());
                        } else {
                            if ($(elem).val().length == 0) {
                                $($binding_target).html($($binding_target).attr('binding-default'))
                            } else {
                                $($binding_target).html($(elem).val());
                            };
                        }
                    } else {
                        if ($(elem).val().length == 0) {
                            $($binding_target).html($($binding_target).attr('binding-default'))
                        } else {
                            $($binding_target).html($(elem).val());
                        }
                    };

                }

                $(this).off('change.binding').on('change.binding', function() {
                    binding_activate(this, false);
                });
                $(this).off('keyup.binding').on('keyup.binding', function() {
                    binding_activate(this, true);
                });

                if ($(this).hasClass('form-field__input--select')) {
                    $(this).trigger('change');
                }
            });

            //for OTP

            $otp.each(function() {
                var $i = $(this);

                $i.off('keyup.otp').on('keyup.otp', function() {
                    if (event.keyCode != 8) {
                        if ($i.val().length > 0) {
                            $i.focusout();
                            $i.closest('.form-field__input-wrapper_otp').next().find('.form-field__input--otp').focus();
                        };
                    } else {
                        $i.focusout();
                        $i.closest('.form-field__input-wrapper_otp').prev().find('.form-field__input--otp').focus();
                    };
                });
            });

            $otp.on('keyup blur', function() {
                var OTPValue = '';

                $.each($otp, function() {
                    OTPValue += $(this).val();
                });

                var otpMain = $(this).closest('.form-field--otp').find('.form-field__input--otp_main')
                otpMain.val(OTPValue);
             });

            
            $otp.on("paste", function() {
                var $this = $(this),
                    originalValue = $this.val(),
                    intRegex = /^\d+$/;
                
                $this.val("");

                $this.one("input.fromPaste", function(){
                    var $currentInputBox = $(this),
                        $currentParent = $currentInputBox.closest('.form-field--otp');
                    
                    var pastedValue = $currentInputBox.val();
                    
                    if (intRegex.test(pastedValue)) {
                        var values = pastedValue.split("");

                        $(values).each(function(index) {
                            var $inputBox = $currentParent.find('.form-field__input--otp[name="chars[' + (index + 1) + ']"]');
                            $inputBox.val(values[index])
                        });
                    }
                    else {
                        $this.val(originalValue);
                    }
                });
            });

            //for Password


            $password.on('keyup blur paste', function() {
                var passwordValue = $(this).val();

                var conditionListItem = $(this).closest('.form-field--password').find('.form-field__messages-password-list');

                validatePassword(conditionListItem,passwordValue)

             });


            


            function validatePassword(list,val) {
                list.find('.form-field__messages-password-list-item').removeClass('valid');

                if (val.length >= 8) {
                    list.find('.message-minimum').addClass('valid');
                }
                if (val.search(/[a-z]/g) >= 0) {
                    list.find('.message-lowercase').addClass('valid');
                }
                if (val.search(/[A-Z]/g) >= 0) {
                    list.find('.message-uppercase').addClass('valid');
                }
                if (val.search(/[0-9]/g) >= 0) {
                    list.find('.message-number').addClass('valid');
                }
                if (val.search(/[!@#$%^&*]/g) >= 0) {
                    list.find('.message-special').addClass('valid');
                }
            }

            $passShowHide.off().on('click', function(e) {

                $(this).toggleClass('button--show button--hide');
                var thisInput = $(this).closest('.form-field--password').find('.form-field__input--password'),
                    visibile = $(this).hasClass('button--show')? true : false;

                    if(visibile){
                        thisInput.attr('type','password')
                    }else{
                        thisInput.attr('type','text')
                    }
                
                e.preventDefault();

            });
            
            //for month pickers

            if (this.$form.parents('[ data-wffm ]').length > 0) {

                // init wffm datepickers
                $datepickersWffm.each(function(i, el) {
                    $dp = $(el).find('input');

                    if (true) {

                        dpLabelId = utils.uniqueID();
                        $dp.parents('.field-border').attr('id', dpLabelId);
                        dpLabelId = '#' + dpLabelId;

                        dpOptions = $dp.data('picker-options');

                        if (typeof dpOptions === 'string') {
                            dpOptions = JSON.parse(dpOptions);
                        } else if (typeof dpOptions !== 'object') {
                            dpOptions = {};
                        }

                        $dp.pickadate(
                            $.extend(
                                true, {
                                    container: dpLabelId
                                },
                                dpOptions,
                                defaultOpts
                            )
                        );
                        // if dp is has a ref dataset update based on this
                        if ($dp.data('ref')) {
                            $dp.on('change', _this.setConstraints);
                        }

                        // IE9clicker (1of2) - as IE9 doesn't have events on pseudoselectors (clicking on calendar icon does not trigger picker)
                        // and as it would be too much work before delivery to update markup of all date fields... go js ugly solution
                        $dp.after('<span data-clicker="' + dpLabelId + '" class="form-field__datepicker-icon-clicker"></span>');

                    } else {

                        $dp.attr('type', 'date');

                        // if dp is has a ref dataset update based on this
                        if ($dp.data('ref')) {
                            $dp.on('change', _this.setConstraintsMobile);
                        }

                    }

                });

            } else {

                // apply validation
                if (this.$form.attr('form-skipvalidation') != 'true') {
                    FormValidation.apply(this.$form);
                    FormValidation.limit();
                }


                // init textarea char count
                $textareas.each(function(i, el) {
                    _this.countTextChars(el);
                });

                $textareas.on('keyup', function() {
                    _this.countTextChars(this);
                });

                // init datepickers
                $datepickers.each(function(i, el) {
                    $dp = $(el);

                    if (true) {

                        dpOptions = $dp.data('picker-options');
                        dpLabelId = '#' + $dp.parents('.form-field').attr('id');

                        if (typeof dpOptions === 'string') {
                            dpOptions = JSON.parse(dpOptions);
                        } else if (typeof dpOptions !== 'object') {
                            dpOptions = {};
                        }

                        $dp.pickadate(
                            $.extend(
                                true,
                                dpOptions,
                                defaultOpts
                            )
                        );

                        // if dp is has a ref dataset update based on this
                        if ($dp.data('ref')) {
                            $dp.on('change', _this.setConstraints);
                        }

                        // IE9clicker (1of2) - as IE9 doesn't have events on pseudoselectors (clicking on calendar icon does not trigger picker)
                        // and as it would be too much work before delivery to update markup of all date fields... go js ugly solution
                        $dp.after('<span data-clicker="' + dpLabelId + '" class="form-field__datepicker-icon-clicker"></span>');

                    } else {

                        $dp.attr('type', 'date');

                        // if dp is has a ref dataset update based on this
                        if ($dp.data('ref')) {
                            $dp.on('change', _this.setConstraintsMobile);
                        }

                    }

                });

                $datepickersFuture.each(function(i, el) {
                    $dp = $(el);

                    if (true) {

                        dpMax = $dp.data('date-max');
                        dpOptions = $dp.data('picker-options');
                        dpLabelId = '#' + $dp.parents('.form-field').attr('id');

                        if (typeof dpOptions === 'string') {
                            dpOptions = JSON.parse(dpOptions);
                        } else if (typeof dpOptions !== 'object') {
                            dpOptions = {};
                        }

                        if (typeof dpMax === 'object') {
                            var maxDay = dpMax[0],
                                maxMonth = dpMax[1],
                                maxYear = dpMax[2],
                                day = new Date();

                            day.setDate(day.getDate() + maxDay);
                            day.setMonth(day.getMonth() + maxMonth);
                            day.setFullYear(day.getFullYear() + maxYear);

                            dpMax = {
                                max: day
                            };

                        } else if (typeof dpMax !== 'object') {
                            dpMax = {};
                        }

                        $dp.pickadate(
                            $.extend(
                                true, {
                                    container: dpLabelId,
                                    min: new Date()
                                },
                                dpOptions,
                                dpMax,
                                defaultOpts
                            )
                        );

                        // if dp is has a ref dataset update based on this
                        if ($dp.data('ref')) {
                            $dp.on('change', _this.setConstraints);
                        }


                        // IE9clicker (1of2) - as IE9 doesn't have events on pseudoselectors (clicking on calendar icon does not trigger picker)
                        // and as it would be too much work before delivery to update markup of all date fields... go js ugly solution
                        $dp.after('<span data-clicker="' + dpLabelId + '" class="form-field__datepicker-icon-clicker"></span>');

                    } else {

                        $dp.attr('type', 'date');

                        // if dp is has a ref dataset update based on this
                        if ($dp.data('ref')) {
                            $dp.on('change', _this.setConstraintsMobile);
                        }
                    }

                });

                $datepickersPast.each(function(i, el) {
                    $dp = $(el);

                    if (true) {

                        dpOptions = $dp.data('picker-options');
                        dpLabelId = '#' + $dp.parents('.form-field').attr('id');

                        if (typeof dpOptions === 'string') {
                            dpOptions = JSON.parse(dpOptions);
                        } else if (typeof dpOptions !== 'object') {
                            dpOptions = {};
                        }

                        $dp.pickadate(
                            $.extend(
                                true, {
                                    container: dpLabelId,
                                    max: new Date()
                                },
                                dpOptions,
                                defaultOpts
                            )
                        );

                        // if dp is has a ref dataset update based on this
                        if ($dp.data('ref')) {
                            $dp.on('change', _this.setConstraints);
                        }


                        // IE9clicker (1of2) - as IE9 doesn't have events on pseudoselectors (clicking on calendar icon does not trigger picker)
                        // and as it would be too much work before delivery to update markup of all date fields... go js ugly solution
                        $dp.after('<span data-clicker="' + dpLabelId + '" class="form-field__datepicker-icon-clicker"></span>');

                    } else {

                        $dp.attr('type', 'date');

                        // if dp is has a ref dataset update based on this
                        if ($dp.data('ref')) {
                            $dp.on('change', _this.setConstraintsMobile);
                        }
                    }

                });

                Date.prototype.addDays = function(days) {
                    var date = new Date(this.valueOf());

                    date.setDate(date.getDate() + days);

                    return date;
                };

                $datepickersBinded.each(function() {
                    var today = new Date(),
                        min = parseInt(jQuery(this).attr('data-el-to_min')),
                        max = jQuery(this).attr('data-el-to_max') != 'indefinite' ? parseInt(jQuery(this).attr('data-el-to_max')) : jQuery(this).attr('data-el-to_max');

                    var from_$input = jQuery(this).pickadate(),
                        from_picker = from_$input.pickadate('picker')

                    var to_$input = jQuery(jQuery(this).attr('data-el-to')).pickadate(),
                        to_picker = to_$input.pickadate('picker')


                    // Check if there’s a “from” or “to” date to start with.
                    if (typeof from_picker !== "undefined" && from_picker.get('value')) {
                        to_picker.set('min', from_picker.get('select').obj.addDays(min))
                    }

                    // When something is selected, update the “from” and “to” limits.
                    if (typeof from_picker !== "undefined") {
                        from_picker.on('set', function(event) {
                            if (event.select) {
                                if (typeof to_picker !== "undefined" && to_picker.get('select') !== null) {
                                    if (from_picker.get('select').obj > to_picker.get('select').obj.addDays(-min) || from_picker.get('select').obj < to_picker.get('select').obj.addDays(-max) ) {
                                        to_picker.clear();
                                    };
                                }
                                to_picker.set('min', from_picker.get('select').obj.addDays(min));
                                if (max != 'indefinite') {
                                    to_picker.set('max', from_picker.get('select').obj.addDays(max));
                                } 
                            } else if ('clear' in event) {
                                to_picker.set('min', today.addDays(min))
                                if (max != 'indefinite') {
                                    to_picker.set('max', today.addDays(max))
                                } 
                            }
                        });
                    };
                    if (typeof to_picker !== "undefined") {
                        to_picker.on('set', function(event) {
                            if (event.select) {
                                //from_picker.set('max', to_picker.get('select').obj.addDays(15))
                                if (typeof from_picker !== "undefined" && from_picker.get('select') !== null) {
                                    if (to_picker.get('select').obj < from_picker.get('select').obj.addDays(min)) {
                                        from_picker.clear();
                                    };
                                }
                            } else if ('clear' in event) {
                                //from_picker.set('max', false)
                            }
                        });
                    }

                });

                // init upload image fields
                $uploaders.on('change', function(e) {

                    //console.log('change')

                    // validate on change

                    //var myFSO = new ActiveXObject("Scripting.FileSystemObject");
                    //var filepath = e.target.value;
                    //var thefile = myFSO.getFile(filepath);
                    //var sizeIE = thefile.size;


                    var ua = window.navigator.userAgent;
                    var msie = ua.indexOf("MSIE ");
                    var ieVersion = parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)))

                    if (ieVersion === 9) // If Internet Explorer, return version number
                    {

                        $container = $(this).closest('.form-field--upload'),
                            id = $(this).data('uploader-field'),
                            $remover = $container.find('[ data-uploader-remove="' + id + '" ]');
                        $previewer = $container.find('[ data-uploader-image="' + id + '" ]'),
                            $filename = $container.find('[ data-uploader-filename="' + id + '" ]');
                        var inspiration_image = e.target.value.split('\\').pop();

                        $previewer.attr('src', $previewer.data('success'));
                        $filename.text(inspiration_image).fadeIn();
                        $remover.fadeIn();

                    }







                    var size = $(this)[0].files[0].size;
                    var exeIndex = $(this)[0].files[0].name.indexOf('.exe');
                    var extension = $(this).val().replace(/^.*\./, '').toLowerCase();
                    var contdd = $(this).closest('.form-field--upload');
                    var $j120 = $(this).closest('.j120-smart-response--button_wrapper');
                    var $j120errorFormat = $j120.find('.form-field__input--upload-format-error-message');
                    var $j120errorSize = $j120.find('.form-field__input--upload-size-error-message');
                    var errorFormat = contdd.find('.form-field__input--upload-format-error-message');
                    var errorSize = contdd.find('.form-field__input--upload-size-error-message');
                    var __this = $(this)

                    errorSize.hide()
                    errorFormat.hide()
                    $j120errorFormat.each(function() {
                        $(this).hide()
                    });
                    $j120errorSize.each(function() {
                        $(this).hide()
                    });

                    var formatList = $(this).data("accepts");

                    if (formatList) {
                        var formats = JSON.parse('[' + formatList.toLowerCase() + ']');
                    }
                    var thisSize = $(this).attr('data-size');

                    


                    if (!formatList && !thisSize && (exeIndex == -1)) {
                        _this.previewUploadedImage(this);

                    } else if ((!formatList && thisSize) || (formatList && !thisSize) || (formatList && thisSize)) {
                        if (exeIndex != -1) {
                            //console.log('error');
                            errorFormat.show();
                            $j120errorFormat.each(function() {
                                $(this).show()
                            });
                            $(this).val("")
                        } else {

                            if (!formatList && thisSize) {

                                if (thisSize >= size) {
                                    _this.previewUploadedImage(this);
                                } else {
                                    errorSize.show();
                                    $j120errorSize.each(function() {
                                        $(this).show()
                                    });
                                    $(this).val("")
                                }
                            }
                            if (formatList && !thisSize) {

                                if (formats.indexOf(extension) > -1) {
                                    _this.previewUploadedImage(this);
                                } else {
                                    errorFormat.show();
                                    $j120errorFormat.each(function() {
                                        $(this).show()
                                    });
                                    $(this).val("")
                                }
                            }
                            if (formatList && thisSize) {

                                if (formats.indexOf(extension) > -1) {
                                    if (thisSize >= size) {
                                        _this.previewUploadedImage(this);
                                    } else {
                                        errorSize.show();
                                        $j120errorSize.each(function() {
                                            $(this).show()
                                        });
                                        $(this).val("")
                                    }
                                } else {
                                    errorFormat.show();
                                    $j120errorFormat.each(function() {
                                        $(this).show()
                                    });
                                    $(this).val("")
                                }
                            }
                        }


                    } else if (exeIndex != -1) {
                        //console.log('error');
                        errorFormat.show();
                        $j120errorFormat.each(function() {
                            $(this).show()
                        });
                        $(this).val("")
                    } else {

                        _this.previewUploadedImage(this);
                    }




                    $(this).parsley().validate();
                });




                // show file if one is already selected, i.e. browser back
                $uploaders.each(function(i, el) {
                    var $el = $(el)[0];

                    if ($el.files && $el.files[0]) { _this.previewUploadedImage(el); }
                });

                // init remove preview upload image buttons
                $previewRemovers.on('click', function(e) {
                    e.preventDefault();
                    _this.removeUploadedImage(this);
                });

                // init checkbox toggles
                $checkboxToggles.on('click', function() {

                    _this.toggleFieldset($(this));

                });




                // init terms checkbox
                $.each($termsCheckbox, function() {
                    var $checkbox = $(this).find('input'),
                        $modalTrigger = $(this).find('a'),
                        $modalContent = $('[data-content=terms_checkbox]'),
                        $agreeButton = $modalContent.find('[data-modal-confirm]'),
                        $closeButton = $modalContent.find('[data-close]');

                    $modalTrigger.on('click', function(e) { e.preventDefault(); });

                    $agreeButton.on('click', function(e) {

                        e.preventDefault();

                        $checkbox.prop('checked', true);
                        $closeButton.trigger('click');


                    });

                });

            }

            // IE9clicker (2of2) - as IE9 doesn't have events on pseudoselectors (clicking on calendar icon does not trigger picker)
            // and as it would be too much work before delivery to update markup of all date fields... go js ugly solution
            $('[ data-clicker ]').on('click', function() {
                $(this).siblings('[ data-el="datepicker" ]').click();
            });

            this.initSelect2();
            $(window).off('form_reinit').on('form_reinit', function() {
                _this.init();
            })

            //Label UI
            this.$form.find('.form-field__input--text').each(function (){
                _this.labelCheckVal($(this));

                $(this).off('focusin.form').on('focusin.form', function() {
                    _this.labelCheckVal($(this));
                });

                $(this).off('focusout.form').on('focusout.form', function() {
                    _this.labelCheckVal($(this));
                });

                $(this).off('keypress.form').on('keypress.form', function() {
                    _this.labelCheckVal($(this));
                });
            });

            this.$form.find('.form-field__input--select').each(function (){
                _this.labelCheckSelectVal($(this));

                $(this).off('change.form').on('change.form', function() {
                    _this.labelCheckSelectVal($(this));
                });
            });

            this.$form.find('.form-field__input--schedule').each(function() {
                $(this).off('keypress.form').on('keypress.form', function (event) {
                    event.preventDefault();
                });
                $(this).off('keyup.form').on('keyup.form', function (event) {
                    event.preventDefault();
                });
                $(this).off('click.form').on('click.form', function (event) {
                     event.preventDefault();

                     $(this).closest('.form-field').find('.m18-modal--schedule .m18-modal__trigger').click();
                });
            });

            this.$form.find('.form-field__input--vip').each(function() {
                $(this).off('keypress.form').on('keypress.form', function (event) {
                    event.preventDefault();
                });
                $(this).off('keyup.form').on('keyup.form', function (event) {
                    event.preventDefault();
                });
                $(this).off('click.form').on('click.form', function (event) {
                     event.preventDefault();

                     $(this).closest('.form-field').find('.m18-modal--vip .m18-modal__trigger').click();
                });
            });
        };

        Form.prototype.labelCheckVal = function($this) {
            var _this = this;

            if ($this.val().length != 0 || $this.is(":focus")) {
                $this.closest('.form-field__label').addClass('focused');
            } else {
                $this.closest('.form-field__label').removeClass('focused');
            }
        };

        Form.prototype.labelCheckSelectVal = function($this) {
            var _this = this;

            if ($this.val() != null) {
                $this.closest('.form-field__label').addClass('focused');
            } else {
                $this.closest('.form-field__label').removeClass('focused');
            }
            if($this.hasClass('uae-select')){
                if($this.val() == '+971'){
                    $this.closest('.form-field').find('.uae-desc').show()
                }else{
                    $this.closest('.form-field').find('.uae-desc').hide()
                }
            }
        };

        Form.prototype.initSelect2 = function() {
            var _this = this;

            $('.form-field__input--select2').each(function() {
                var $parent = $(this).closest('.form-field'),
                    $placeholder = ($(this).attr('data-placeholder') == null || undefined) ? '' : $(this).attr('data-placeholder'),
                    $noresult = ($(this).attr('data-noresult') == null || undefined) ? '' : $(this).attr('data-noresult'),
                    ver2 = ($(this).hasClass('form-field__input--select2-v2')) ? true : false,
                    ver1 = ($(this).hasClass('form-field__input--select2-ver1')) ? true : false,
                    moreTxt = (ver2) ? $(this).attr('data-more') : '';

                function matchStart(params, data) {
                        if ($.trim(params.term) === '') {
                            return data;
                        }
                        if (data.text.toLowerCase().startsWith(params.term.toLowerCase())) {
                            return data;
                        }
                        return null;
                    }
                    function formatSelected(data) {
                        if (!data || data.length === 0) {
                            return '';
                        } else if (data.length === 1) {
                            return data[0].text;
                        } else {
                            return `${data[0].text} +${data.length - 1} ${moreTxt}`;
                        }
                    }


                if (!ver2){
                    var $v1Select = $(this);
                    $(this).select2({
                        width: '100%',
                        placeholder: $placeholder,
                        matcher: matchStart,
                        dropdownCssClass : 'select2-dropdown-v1',
                        language: {
                            noResults: function() {
                                return $noresult;
                            }
                        }
                    });
                }else{
                    var $v2Select = $(this);
                    $(this).select2({
                        width: '100%',
                        placeholder: $placeholder,
                        matcher: matchStart,
                        selectionCssClass : 'select2-container-v2',
                        closeOnSelect: false,
                        language: {
                            noResults: function() {
                                return $noresult;
                            }
                        },
                        templateSelection: function (selection) {
                            if ($v2Select.hasClass('select2-hidden-accessible')) {
                                    const selectedItems = $v2Select.select2('data');
                                    return formatSelected(selectedItems);
                            }
                        }
                    });
                    $v2Select.on('change.select2', function (e) {
                        const selectedItems = $v2Select.select2('data');
                        $parent.find('.select2-selection__rendered').text(formatSelected(selectedItems));
                        if(selectedItems.length < 1){
                            $parent.addClass('not-selected')
                        }else{
                            $parent.removeClass('not-selected')
                            $parent.find('.select2-search__field').val('')
                        }
                    });
                    $v2Select.on('select2:open', function() {
                        var thisWrapper = $(this).closest('.form-field__input-wrapper--select2'),
                            selectInp = thisWrapper.find('.select2-search__field'),
                            selectRender = thisWrapper.find('.select2-selection__rendered');
                            selectInp.on('focus', function() {
                            selectRender.hide();
                        });
                    });
                    $v2Select.on('select2:select', function() {
                        var thisWrapper = $(this).closest('.form-field__input-wrapper--select2'),
                            selectRender = thisWrapper.find('.select2-selection__rendered');
                        selectRender.show();
                    });
                    $v2Select.on('select2:close', function() {
                        var thisWrapper = $(this).closest('.form-field__input-wrapper--select2'),
                            selectRender = thisWrapper.find('.select2-selection__rendered');
                        selectRender.show();
                    });
                }

                
                if(ver1){
                    var $v1Select = $(this);
                    $v1Select.on('change.select2', function (e) {
                        const selectedItems = $v1Select.select2('data');
                        if(selectedItems.length < 1){
                            $parent.addClass('not-selected')
                        }else{
                            $parent.removeClass('not-selected')
                            $parent.find('.select2-search__field').val('')
                        }
                    });
                }

                $parent.find('.select2-selection__arrow').remove();
                $parent.find('.select2-selection').css('height', 'auto');
                if (($(this).hasClass('j120-location-form-field__input--select2') && !utils.isRTL()) || (!$(this).hasClass('j120-location-form-field__input--select2') && utils.isRTL())) {
                    $parent.find('.select2-selection__rendered').css({ 'padding': '5px 12px 8px', 'padding-left': '44px' });
                } else if (($(this).hasClass('j120-location-form-field__input--select2') && utils.isRTL()) || (!$(this).hasClass('j120-location-form-field__input--select2') && !utils.isRTL())) {
                    $parent.find('.select2-selection__rendered').css({ 'padding': '5px 12px 8px', 'padding-right': '44px' });
                }
            });
        };

        Form.prototype.setConstraints = function() {
            var $el = $(this),
                ref = $el.data('ref'),
                refDate = $el.pickadate('picker').get('select'),
                minPickers = $('[data-mindate="' + ref + '"]'),
                maxPickers = $('[data-maxdate="' + ref + '"]');

            refDate = refDate ? refDate.pick : false;

            // update min and max dates
            minPickers.each(function(i, picker) {
                var $picker = $(picker),
                    currentDate = $picker.pickadate('picker').get('select'),
                    minOffset = parseInt($picker.data('mindate-offset'), 10) * 86400000,
                    newMin = refDate ? refDate + minOffset : false,
                    updateObj = { 'min': new Date(newMin) };

                if (currentDate && newMin) {
                    updateObj.select = (currentDate && currentDate.pick < newMin) ? newMin : currentDate.pick;
                }

                $picker.pickadate('picker').set(updateObj);
            });

            maxPickers.each(function(i, picker) {
                var $picker = $(picker),
                    currentDate = $picker.pickadate('picker').get('select'),
                    maxOffset = parseInt($picker.data('maxdate-offset'), 10) * 86400000,
                    newMax = refDate ? refDate + maxOffset : false,
                    updateObj = { 'max': new Date(newMax) };

                if (currentDate && newMax) {
                    updateObj.select = (currentDate && currentDate.pick > newMax) ? newMax : currentDate.pick;
                }

                $picker.pickadate('picker').set(updateObj);
            });
        };

        Form.prototype.setConstraintsMobile = function() {
            var $el = $(this),
                ref = $el.data('ref'),
                refDate = $el.val(),
                minPickers = $('[data-mindate="' + ref + '"]'),
                maxPickers = $('[data-maxdate="' + ref + '"]');

            // update min and max dates
            minPickers.prop('min', refDate);
            maxPickers.prop('max', refDate);
        };


        Form.prototype.countTextChars = function(textarea) {

            var $textarea = $(textarea),
                $count = $('[ data-charcount="' + $textarea.data('textarea') + '" ]');

            $count.text($textarea.val().length);
        };


        Form.prototype.scrollIntoView = function($node) {

            $('html, body').animate({
                scrollTop: ~~$node.offset().top - 60
            }, 750);
        };


        Form.prototype.previewUploadedImage = function(input) {
            var $input = $(input),
                $container = $input.closest('.form-field--upload'),
                id = $input.data('uploader-field'),
                $remover = $container.find('[ data-uploader-remove="' + id + '" ]');

                if( $input.hasClass('wetex') ) {
                    var thisWrapper = $input.closest('.form-field__input-wrapper'),
                        fileExt = thisWrapper.find('.file-ext-txt'),
                        fileName = thisWrapper.find('.file-name'),
                        fileSize = thisWrapper.find('.file-size');
                        
                    fileExt.html($input.val().replace(/^.*\./, ''))
                    fileName.html($input[0].files[0].name)
                    fileSize.html(bytesToSize($input[0].files[0].size))
                    thisWrapper.find('.form-field__preview-wrapper').removeClass('hidden')
                    thisWrapper.addClass('upload-preview-mode')
                    $('.remove-upload').on('click',function(){
                        var thisParrentWrap = $(this).closest('.form-field__input-wrapper'),
                            thispreview = thisParrentWrap.find('.form-field__preview-wrapper'),
                            $thisInput = thisParrentWrap.find('.form-field__input--upload');
                            $thisInput.val('')
                            thispreview.addClass('hidden')
                            thisParrentWrap.removeClass('upload-preview-mode')
                    })
                }

                function bytesToSize(bytes) {
                    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
                    if (bytes == 0) return '0 Byte';
                    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
                    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
                 }


            if (input.files && input.files[0]) {

                var reader,
                    isImage = false,
                    filename = input.files[0].name,
                    $previewer = $container.find('[ data-uploader-image="' + id + '" ]'),
                    $filename = $container.find('[ data-uploader-filename="' + id + '" ]');


                if (window.FileReader && window.Blob && /image/i.test(input.files[0].type)) {

                    reader = new FileReader();

                    reader.onload = function(e) {
                        $previewer.attr('src', e.target.result);
                    };

                    reader.readAsDataURL(input.files[0]);

                    isImage = true;
                }

                if (isImage === false) { // not an image - use the 'success' placeholder image
                    $previewer.attr('src', $previewer.data('success'));
                }

                // console.log(input.val());
                $filename.text(filename).fadeIn();
                $remover.fadeIn();
            } else {
                this.removeUploadedImage($remover[0]);
            }

        };


        Form.prototype.removeUploadedImage = function(button) {

            var $button = $(button),
                $container = $button.closest('.form-field--upload'),
                id = $button.data('uploader-remove'),
                $previewer = $container.find('[ data-uploader-image="' + id + '" ]'),
                $uploader = $container.find('[ data-uploader-field="' + id + '" ]'),
                $filename = $container.find('[ data-uploader-filename="' + id + '" ]');

            //console.log($uploader.val())



            $previewer.attr('src', $previewer.data('src'));
            $uploader.val('').focus();
            if (/MSIE/.test(navigator.userAgent)) {
                $uploader.replaceWith($uploader = $uploader.clone(true));
            }
            $filename.text('').fadeOut();
            //console.log($uploader.val())
            $button.fadeOut();

        };

        Form.prototype.toggleFieldset = function($checkox) {

            var $fieldset = $('#' + $checkox.attr('aria-controls')),
                expanded = $fieldset.attr('aria-expanded') === 'true',
                pressed = $fieldset.attr('aria-pressed') === 'true',
                childrenFields = $fieldset.find('input[type=text], input[type=number], input[type=email]').not('[data-el=datepicker]');

            $checkox.attr('aria-pressed', pressed = !pressed);
            $fieldset.attr('aria-expanded', expanded = !expanded);
            $fieldset.toggleClass('fieldset--hidden');

            if (!$fieldset.hasClass('fieldset--hidden')) {
                // enable validation on child fields
                childrenFields.parsley({
                    excluded: 'input.form-field__input--readonly, input[type=button], input[type=submit], input[type=reset], input[type=hidden], [disabled], :hidden'
                });
            }
        };

        return Form;

    });

